import { apiGetSetInfosObjetsFormActSess, apiRecupereInfoGet, apiGetProprietes } from './Datas/datasAutre.js'
import { apiVolumesObjetsLheo  } from './Datas/datasAutre.js'

// pour reactform
export const onError = (error) => {
    console.log("ERROR:::", error);
};

/**
 * set du nombre d'objet (action formation et session) total, en attente et incomplet
 */
export async function recupererVolumes(utilisateurBearer, setNbFormTot, setNbFormAttente, setNbFormIncomplete, setNbActAttente, 
    setNbActIncomplete, setNbSessAttente, setNbSessIncomplete, setNbSessNonHabilitees, setMessageProbleme) {  // récupére nbFoTot, nbFoRejetLheo, nbFoRejetCarif
    var dataVolumes = await apiVolumesObjetsLheo(utilisateurBearer); 
    if(global.config.modeDebugApp == 1) console.log('retour apiVolumesObjetsLheo : ', dataVolumes)

    switch (dataVolumes.statusCode) {
    case 200:
            setNbFormTot(dataVolumes.dataApi.nbFoTot);
            setNbFormAttente(dataVolumes.dataApi.nbFoRejetCarif);
            setNbFormIncomplete(dataVolumes.dataApi.nbFoRejetLheo);
            
            setNbActAttente(dataVolumes.dataApi.nbActRejetCarif);
            setNbActIncomplete(dataVolumes.dataApi.nbActRejetLheo);
            
            setNbSessAttente(dataVolumes.dataApi.nbSessRejetCarif);
            setNbSessIncomplete(dataVolumes.dataApi.nbSessRejetLheo);
            setNbSessNonHabilitees(dataVolumes.dataApi.nbSessNonHabilitees);
        break;
    case 401:
        setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
        break;
    default:
        setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
    }
}

// a faire :
// update PERSONS set password_encrypter = '9fcbc16de06246ed37268d755aeadee9' where  id_persons = 157723 and password = '*Gémenos78!%' and p.password_encrypter = 'cdbe25d0749f2e2062c4d7b83c278f43'
export function MD5(d){ //maj le 050825 car vu des pb avec les caractères accentués auparavant
    var MD5 = require("crypto-js/md5");
    var e = MD5(d).toString()
    return e;
}


/**
 * changer la date 2022-08-12 en 20220812
 */
export function dateModifCharAmericAvecSepToAmericSansSep(val) {
    if(val !== null && val.length == 10) {
        val = val.substring(0, 4) + val.substring(5, 7) + val.substring(8, 10);
        //console.log("date avec retrait separateur : ", val);
        return val;
    }
    else return null;
}

/**
 * changer la date 20220812 en 2022-08-12 
 */
export  function dateModifCharAmericSansSepToAmericAvecSep(val, sep="-") {
    if(val !== null && val.length == 8) {
        val = val.substring(0, 4) + sep + val.substring(4, 6) + sep + val.substring(6, 8);
        //console.log("date avec ajout separateur : ", val);
        return val;
    }
    else return null;
}

/**
 * changer la date 2018-09-27 00:00:00.000 en 2022-08-12 
 */
export  function dateModifSmallDatTimeToAmericAvecSep(val) {
    if(val !== undefined && val !== null && val.length > 9) { // normalement 23 longueur
        val = val.substring(0, 10);
        //console.log("date après modif : ", val);
        return val;
    }
    else return null;
}

export function verifOrdreDateDebutFin (debut, fin, message="La date de fin doit être supérieure à la date de début") {
    if(debut != "" && fin != "" && debut > fin) {
      alert(message);
      return false;
    }
    return true;
}

export function verifOrdreHeureDebutFin (debut, fin) {
    if(debut != "" && fin != "" && debut >= fin) {
      alert("L'heure de fin doit être posterieure à celle début");
      return false;
    }

    return true;
}

export function verifConformiteHeureHHhMM (heure, limB='', limH='') {
    if(heure == undefined) return true;

    let msgErreur = "";

    if(heure.length != 5)                   msgErreur = `L'heure doit être inscrite comme suit : 08h30`;
    else if(heure.substring(2, 3) != 'h')   msgErreur = `L'heure doit être inscrite comme suit : 08h30`;
    if(msgErreur == "") {
        const tab = heure.split('h');        

        if (tab.length != 2 || tab[0].length != 2 || tab[1].length != 2 || isNaN(tab[0]) || isNaN(tab[1])) msgErreur = `Le format de l'heure ${heure} est incorrect`;
        else if(tab[0] < 0 || tab[0] > 23)  msgErreur = `Le format de l'heure pour l'heure ${heure} est incorrect`;
        else if(tab[1] < 0 || tab[1] > 59)  msgErreur = `Le format des minutes pour l'heure ${heure} est incorrect`;

        else if(limB != '' && tab[0] < limB)  msgErreur = `L'heure ne peut être inférieure à ${limB}h`;
        else if(limH != '' && (tab[0] > limH || (tab[0] == limH && tab[1] > 0)))  msgErreur = `L'heure ne peut être supérieure à ${limH}h`;
    }
    
    if(msgErreur != "") {
        alert (msgErreur);
        return false;
    }
    else return true;
}

/**
 * convertir un timestamp en date au format fr ex : 30/04/2024
 * @param {timestamp} timestamp 
 * @return 
 */
export function convertTimeToday(timestamp) {
    let aDate = ''
    if (timestamp !== '') {
        var date = new Date(timestamp);
        aDate= monthOrDay2digits(date.getDate()) + "/"+monthOrDay2digits(date.getMonth()+1) +  "/"+date.getFullYear()
        if(global.config.modeDebugApp == 1) console.log(`${timestamp} converted to ${aDate}`)
    }
    else {
        if(global.config.modeDebugApp == 1) console.log(`${timestamp} connot be converted`)
    }
    return aDate

    function monthOrDay2digits(month)    { 
        return (month < 10 ? '0' : '') + month;
    }
}

// identique a ci dessus a priori.. fait par myself
// transforme timestamp (2025-06-13T00:00:00 à l'affichage) en 13/06/2025
export function convertSmallDateTimeToLocalDateStr(timestamp, pays="fr", forceAffichage=0) {
    if(timestamp == null || timestamp.substring(0,4) <= 1900) {
        if(forceAffichage == 0) return null;
        else return "n.c.";
    }
    let tt =  new Date(timestamp).toLocaleDateString(pays);
    //console.log(`${timestamp} transformé en ${tt}`);
    return tt;
}

//https://stackoverflow.com/questions/23593052/format-javascript-date-as-yyyy-mm-dd
// ou https://isotropic.co/how-to-format-a-date-as-dd-mm-yyyy-in-javascript/
export function dateDuJourYYYYmmdd() {
    var d = new Date(),
        month = '' + (d.getMonth() + 1),  // bien laisser le  +1 car démarre à 0 pour janvier
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}


/**
 * retourne la date d'il y a 6 mois au format YYY-MM-DD
 */
export function dateSixMoisAnterieurYYYYmmdd() {
    const sixMonthAgo = new Date()    
    sixMonthAgo.setDate(sixMonthAgo.getDate() - 180)

    var month = '' + (sixMonthAgo.getMonth()+1); // bien laisser le  +1 car démarre à 0 pour janvier
    var day = '' + sixMonthAgo.getDate();
    var year = sixMonthAgo.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;

    return [year, month, day].join('-');
}


/**
 * retourner la date dans XX années au format YYY-MM-DD
 */
export function dateDansXXAnsYYYYmmdd(ans=3) {
    const treeyarslater = new Date()   
    treeyarslater.setFullYear(treeyarslater.getFullYear() + ans); //.setDate(treeyarslater.getDate() +1095 )//1095 = 365*3

    var month = '' + (treeyarslater.getMonth()+1); // bien laisser le +1 car démarre à 0 pour janvier
    var day = '' + treeyarslater.getDate();
    var year = treeyarslater.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return [year, month, day].join('-');
}


/**
 * retourner une date au format DD/MM/YYYY
 */
export function dateDansXXAnsddmmYYYY(ans=3) {
    const treeyarslater = new Date()   
    treeyarslater.setFullYear(treeyarslater.getFullYear() + ans); //.setDate(treeyarslater.getDate() +1095 )//1095 = 365*3

    var month = '' + (treeyarslater.getMonth()+1); // bien laisser le  +1 car démarre à 0 pour janvier
    var day = '' + treeyarslater.getDate();
    var year = treeyarslater.getFullYear();

    if (month.length < 2) 
        month = '0' + month;
    if (day.length < 2) 
        day = '0' + day;
    return [day, month, year].join('/');
}

/**
 * changer une date 11/12/2022 en 20221211
 */
export function dateModifCharFrToAmericSansSep(val) {
    if(val !== null && val.length == 10) {
        var valRet =  val.substring(6, 10) + val.substring(3, 5) + val.substring(0, 2);
        //console.log("date modifée : ", valRet);
        return valRet;
    }
    else return null;
}

//https://www.developpez.net/forums/d643063/webmasters-developpement-web/general-conception-web/contribuez/faq-verifier-validite-d-date/
// retourne également true si null
export function validateDate(dateStr) {
    if(dateStr == null) return true;

    var dateArr = dateStr.split('-');
    var newDate = new Date(dateArr[0], parseInt(dateArr[1],10)-1, parseInt(dateArr[2])); // format retourné par un input date : 1990-10-22
    return newDate.getMonth() == parseInt(dateArr[1],10)-1;
}


export function afficheElement (intit, contenu, isTexteRiche=false, className="intitule-detail-fiche") {
    if(contenu == null || contenu == "") return(<></>);
    else {
    if(isTexteRiche == false && contenu.toString().length < 255) 
        return(<div className="element-detail"><span className={className}>{intit} : </span>{contenu}
                </div>)
    else 
        return(<div  className="element-detail">
                <div  className="intitule-detail-fiche">{intit} :</div>
                {isTexteRiche == false ? <div>{contenu}</div> : <div style={{paddingLeft: "10px"}} dangerouslySetInnerHTML={{  __html: contenu }}></div>}
                </div>)
    }
}


export function afficheElementCheck (intit, contenu, className="intitule-detail-fiche") {
    //if(contenu == null || contenu == "") return(<>n.c.</>);
    //else {
     return(<div>
                <span className={className}>{intit} </span>
                { (contenu == true) ?  <i className="fa-solid fa-check"></i>
                : (contenu == false) ? <i className="fa-sharp fa-solid fa-ban"></i> :
                <>n.c.</>
                }
            </div>)
    //}
}


export async function appelGetSetInfosObjetsFormActSess(utilisateurBearer, formationNumber, actionNumber, sessionNumber, SetInfosGenFormation, setMessageProbleme) {
    const dataR = await apiGetSetInfosObjetsFormActSess(utilisateurBearer, formationNumber, actionNumber, sessionNumber);
    if(global.config.modeDebugApp == 1) console.log('retour apiGetSetInfosObjetsFormActSess (api "gestion-infos-objets-form-act-sess") : ', dataR);

    switch (dataR.statusCode) {
        case 200:
            SetInfosGenFormation(dataR.dataApi); // infosGenFormation est passé à leftMenu et à LiensPrecedentSuivant
            return true;
        case 401:
           setMessageProbleme(global.config.msgPrTechnique.msgUnauthorized); // Problème technique Unauthorized
            break;
        case 400:
            setMessageProbleme(dataR.dataApi + global.config.msgPrTechnique.msgUnauthorizedAccessObject); // un message personnalisé est retourné dans ce cas, ex : "Formation avec l'id XXXX introuvable.. Vous n'avez pas les droits pour accéder à la formation ayant l'id XXXX"
            break;
      default:
           setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
    }
    return false;
}

export async function recupererProprietes(utilisateurBearer, formationNumber, actionNumber, sessionNumber, SetInfosProprietes, setMessageProbleme) {
    const dataR = await apiGetProprietes(utilisateurBearer, formationNumber, actionNumber, sessionNumber);
    if(global.config.modeDebugApp == 1) console.log(`---------retour apiGetProprietes avec formationNumber ${formationNumber}, actionNumber ${actionNumber}, sessionNumber ${sessionNumber} : `, dataR);
    switch (dataR.statusCode) {
      case 200:
        SetInfosProprietes(dataR.dataApi);
        return true;
      default:
        setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
    }
    return false;
 }
 
//import { appelRecupInfoGet } from '../../fonctionsDiv.js'
// utilisation : var ret = await appelRecupInfoGet(utilisateurBearer, XXXXXXXXXXXXXX, setMessageProbleme);
export async function appelRecupInfoGet(utilisateurBearer, nomAction, setMessageProbleme) {
    const dataR = await apiRecupereInfoGet(utilisateurBearer, nomAction);
    //if(global.config.modeDebugApp == 1) console.log(`retour apiRecupereInfoGet avec ${nomAction} : `, dataR);
    switch (dataR.statusCode) {
        case 200:            
            return dataR.dataApi;
        default:
            setMessageProbleme(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
            return null;
    }
}

export function retourneCauseInterdictionForm(cause_intervention_interdite, verbose=0) {
    var retour = "Suppression impossible : ";
    if(verbose == 1) retour = "Impossible de supprimer cette formation car ";

    if(cause_intervention_interdite == "conventionnee") retour += " au moins une de ses actions est conventionnée";
    else if(cause_intervention_interdite == "perimee_moins_90") retour += "au moins une de ses sessions est perimée depuis moins de 60 jours.";
    else if(cause_intervention_interdite == "encours_ou_a_venir") retour += "au moins une de ses sessions est en cours ou à venir.";
    else retour += " vous n'avez pas les droits"; // pour formation_prst4 à la base
    return retour;
}

export function retourneCauseInterdictionAct(cause_intervention_interdite, verbose=0) {
    var retour = "Suppression impossible : ";
    if(verbose == 1) retour = "Impossible de supprimer cette action car ";

    if(cause_intervention_interdite == "conventionnee") retour += "c'est une action conventionnée";
    else if(cause_intervention_interdite == "pas_proprietaire") retour += "vous n'êtes pas autorisé à supprimer une action dont vous n'êtes pas propriétaire.";
    else if (cause_intervention_interdite == "perimee_moins_90") retour += "au moins une de ses sessions est périmée depuis moins de 60 jours.";
    else if(cause_intervention_interdite == "encours_ou_a_venir") retour += "au moins une de ses sessions est en cours ou à venir.";
    else retour += " vous n'avez pas les droits";
    return retour;
}


export function retourneCauseInterdictionSess(cause_intervention_interdite, verbose=0) {
    var retour = "Suppression impossible : ";
    if(verbose == 1) retour = "Impossible de supprimer cette session car ";

    if(cause_intervention_interdite == "conventionnee") retour += "c'est une action conventionnée";
    else if(cause_intervention_interdite == "pas_proprietaire")   retour += "vous n'êtes pas autorisé à supprimer une session dont vous n'êtes pas propriétaire.";
    else if(cause_intervention_interdite == "perimee_moins_90")   retour += " elle a déjà été envoyée dans l'éco système et elle est périmée depuis moins de 60 jours.";
    else if(cause_intervention_interdite == "encours_ou_a_venir") retour += " elle a déjà été envoyée dans l'éco système et elle est en cours ou à venir.";
    else retour += " vous n'avez pas les droits";
    return retour;
}

export function confirmationSiCLickSUrLien(event) {
    var ob = document.getElementById("hidden_marque_une_modif");
    if(ob != undefined && ob != null && ob.value == 1) {
      if (!confirm(" Êtes-vous sûr de vouloir quitter cette page ? Vos données non sauvegardées seront perdues.")) {
        event.preventDefault(); // Empêche le lien de s'exécuter
      }
    }
} 


/**
 * transformer true ou false en 1 ou 0
 */
export function ajusteDonneesBool (data) {
    if(data == true) return 1;
    else if(data == false) return 0;
    else return null;
}


/**
 * vérifier si un siret est ok sur le format + lhun
 * @param {string} siret 
 * @return {boolean}
 */
export function isValidSIRET(siret) {
    // Vérifier que la longueur est de 14 chiffres et que ce sont tous des chiffres
    if (siret.length !== 14 || !/^\d+$/.test(siret)) {
        return false;
    }

    // Algorithme de Luhn pour vérifier le SIRET
    let sum = 0;
    for (let i = 0; i < 14; i++) {
        let num = parseInt(siret[i]);
        if (i % 2 === 0) { // Double les chiffres de position pair (en partant de 0)
            num = num * 2;
            if (num > 9) {
                num = num - 9; // Si le résultat est supérieur à 9, soustraire 9
            }
        }
        sum += num;
    }

    // Si la somme est un multiple de 10, le SIRET est valide
    return (sum % 10) === 0;
}

export function hdleClickNoPossible (message="Vous n'avez pas les droits pour modifier cette information.") {
    alert(message);
}